import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuantityStepperALV1Component } from './components/quantity-stepper-al-v1/quantity-stepper-al-v1.component';
import { FormsModule } from '@angular/forms';
import { QuantityDropdownALV1Component } from './components/quantity-dropdown-al-v1/quantity-dropdown-al-v1.component';

import { ToasterModule } from 'abs-ngx-library/src/lib/toaster-al';
import { ProductSNSModalALComponent } from './components/product-sns-modal-al/product-sns-modal-al.component';
import { ProductSNSModalALService } from './components/product-sns-modal-al/product-sns-modal-al.service';
import { QuantityStepperALV2Component } from './components/quantity-stepper-al-v2/quantity-stepper-al-v2.component';
import { CartSlotModalALComponent } from './components/card-slot-modal-al/cart-slot-modal-al.component';
import { QuantityStepperSimpleAlV1Component } from './components/quantity-stepper-simple-al-v1/quantity-stepper-simple-al-v1.component';

@NgModule({
  declarations: [QuantityStepperALV1Component, QuantityStepperALV2Component, QuantityDropdownALV1Component, ProductSNSModalALComponent, CartSlotModalALComponent],
  exports: [
    QuantityStepperALV1Component,
    QuantityStepperALV2Component,
    QuantityDropdownALV1Component,
    CartSlotModalALComponent,
    QuantityStepperSimpleAlV1Component
  ],
  imports: [
    CommonModule,
    FormsModule,
    ToasterModule,
    QuantityStepperSimpleAlV1Component
  ],
  providers: [
    QuantityStepperALV1Component,
    QuantityStepperALV2Component,
    QuantityDropdownALV1Component,
    ProductSNSModalALService
  ]
})
export class QuantityStepperModule { }